// Copyright (c) 2020 Sagacity Solutions Inc. All right reserved.
'use strict';

import { BrowserDefaultLanguage } from "@/lib/translator"
import moment from "moment-timezone";
import 'moment/locale/es';

var storage = window.localStorage;
var defaultLanguage = (storage && storage.getItem('language')) || BrowserDefaultLanguage();

moment.locale(defaultLanguage);
    
export default {
  namespaced: true,
  state: {
    selectedLanguage: defaultLanguage,
  },
  mutations: {
    setLanguage(state, lang) {
      storage.setItem('language', lang);
      moment.locale(lang);
      state.selectedLanguage = lang;
    }
  },
}
